import { createContext, useContext, useEffect, useState } from "react";
import { getFirebaseIDToken } from "../../../functions/firebase/firebase";
import { getAllExactCustomers, getAllExactProducts } from "../../../functions/api/exact";
import { useAuth } from "../firebase/useAuth";

const ExactContext = createContext();

export const ExactProvider = ({ children }) => {
  const [exactProducts, setExactProducts] = useState(null);
  const [exactCustomers, setExactCustomers] = useState(null);
  const [loading, setLoading] = useState(false);
  const { isAuthenticated, loading: authLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated && !authLoading && (!exactProducts || !exactCustomers)) {
      setLoading(true);
      getFirebaseIDToken()
        .then((token) => {
          const promises = [];

          if (!exactProducts) {
            promises.push(
              getAllExactProducts(token)
                .then((data) => {
                  setExactProducts(data);
                  return data;
                })
                .catch((err) => {
                  console.log("Error fetching exact products: ", err);
                  return null;
                }),
            );
          }

          if (!exactCustomers) {
            promises.push(
              getAllExactCustomers(token)
                .then((data) => {
                  setExactCustomers(data);
                  return data;
                })
                .catch((err) => {
                  console.log("Error fetching exact customers: ", err);
                  return null;
                }),
            );
          }

          return Promise.all(promises);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [isAuthenticated, authLoading, exactProducts, exactCustomers]);

  const value = {
    products: exactProducts,
    customers: exactCustomers,
    loading,
  };

  return <ExactContext.Provider value={value}>{children}</ExactContext.Provider>;
};

export const useExact = () => {
  const context = useContext(ExactContext);
  if (context === undefined) {
    throw new Error("useExact must be used within an ExactProvider");
  }
  return context;
};
